import React, { useEffect, useRef, useState } from "react";

// Tester-only rating of a stored assistant answer (feature AI_ANSWER_REVIEW). The server keeps the review on the answer row.
export const REVIEW_REASONS = [
  { code: "WRONG_INFO", label: "מידע שגוי" },
  { code: "MISUNDERSTOOD", label: "ענה על שאלה אחרת" },
  { code: "UNCLEAR", label: "התשובה לא מובנת" },
  { code: "OTHER", label: "אחר" }
];
export const MAX_REVIEW_COMMENT_CHARACTERS = 2000;

const THUMB_UP_PATH = "M7 11v8a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h3a4 4 0 0 0 4 -4v-1a2 2 0 0 1 4 0v5h3a2 2 0 0 1 2 2l-1 5a2 3 0 0 1 -2 2h-7a3 3 0 0 1 -3 -3";
const THUMB_DOWN_PATH = "M7 13v-8a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v7a1 1 0 0 0 1 1h3a4 4 0 0 1 4 4v1a2 2 0 0 0 4 0v-5h3a2 2 0 0 0 2 -2l-1 -5a2 3 0 0 0 -2 -2h-7a3 3 0 0 0 -3 3";

function ThumbIcon({ path }) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d={path} /></svg>;
}

export function AnswerReviewButtons({ review, saving, failed, onRate, onEditComment }) {
  const rating = review?.rating || null;
  const hasDetails = Boolean(review?.comment || review?.reasons?.length);
  return <div className="ai-assistant-review" role="group" aria-label="דירוג התשובה">
    <button type="button" className={`ai-assistant-review-thumb${rating === "up" ? " ai-assistant-review-up" : ""}`} aria-label="תשובה טובה" aria-pressed={rating === "up"} disabled={saving} onClick={() => onRate("up")}><ThumbIcon path={THUMB_UP_PATH} /></button>
    <button type="button" className={`ai-assistant-review-thumb${rating === "down" ? " ai-assistant-review-down" : ""}`} aria-label="תשובה לא טובה" aria-pressed={rating === "down"} disabled={saving} onClick={() => onRate("down")}><ThumbIcon path={THUMB_DOWN_PATH} /></button>
    {rating === "down" ? <button type="button" className="ai-assistant-review-comment" disabled={saving} onClick={onEditComment}>{hasDetails ? "עריכת הערה" : "הוספת הערה"}</button> : null}
    {failed ? <span className="ai-assistant-review-failed" role="alert">הדירוג לא נשמר. נסו שוב.</span> : null}
  </div>;
}

export function AnswerReviewDialog({ review, onSave, onCancel }) {
  const [reasons, setReasons] = useState(review?.reasons || []);
  const [comment, setComment] = useState(review?.comment || "");
  const commentRef = useRef(null);
  useEffect(() => { commentRef.current?.focus(); }, []);
  const toggleReason = (code) => setReasons((current) => current.includes(code) ? current.filter((item) => item !== code) : [...current, code]);
  const save = (event) => {
    event.preventDefault();
    onSave({ rating: "down", reasons: REVIEW_REASONS.map((reason) => reason.code).filter((code) => reasons.includes(code)), comment: comment.trim() || null });
  };
  return <div className="ai-assistant-review-backdrop" onMouseDown={(event) => { if (event.target === event.currentTarget) onCancel(); }}>
    <form className="ai-assistant-review-dialog" role="dialog" aria-modal="true" aria-labelledby="ai-assistant-review-title" onSubmit={save}>
      <strong id="ai-assistant-review-title">מה לא תקין בתשובה?</strong>
      <div className="ai-assistant-review-reasons">{REVIEW_REASONS.map((reason) => <button key={reason.code} type="button" aria-pressed={reasons.includes(reason.code)} className={reasons.includes(reason.code) ? "ai-assistant-review-reason-selected" : ""} onClick={() => toggleReason(reason.code)}>{reason.label}</button>)}</div>
      <textarea ref={commentRef} aria-label="הערה" placeholder="מה היה צריך לענות? (לא חובה)" rows={4} maxLength={MAX_REVIEW_COMMENT_CHARACTERS} value={comment} onChange={(event) => setComment(event.target.value)} />
      <div className="ai-assistant-review-actions"><button type="submit" className="ai-assistant-review-save">שמירה</button><button type="button" className="ai-assistant-review-cancel" onClick={onCancel}>ביטול</button></div>
    </form>
  </div>;
}
